import React from 'react';
import { userTypeDrop } from '../../../../../enums/userTypeEnumDrop';
import Tooltip from '@mui/material/Tooltip';
import CustomModal from '../../../../../components/Modal/CustomModal';
import ApproveDocumentApp from "../Functionality/ApproveDocumentApp";

const ApproveDocumentModal = (props) => {
    const {userType, employeeName, itemName} = props;
    const {t, handle}  = ApproveDocumentApp(props);

    return (
        <>
            <CustomModal
                title={'approve'}
                size='md'
                buttonConfirm='confirm'
                classNameBody="pt-2"
                {...props}
                onConfirm={() => {
                    handle();
                }}
            >
                <div className={"row"}>
                    <div className={"col-12 d-flex justify-content-center align-items-center"}>
                        <span className='modal-desc-text'>
                            {t('are_you_sure_you_want_to_approve_the_document')}
                            <strong>
                                <Tooltip title={props.documentName.toUpperCase()} placement='top'>
                                    <p className='ms-1 d-none d-sm-inline ellipsis-one-line'>
                                        {props.documentName.length > 30
                                            ? props.documentName?.slice(0, 30) + '...'
                                            : props.documentName}
                                    </p>
                                </Tooltip>
                            </strong>
                            {' ' + t('for_the').toLowerCase()}
                            { itemName ?
                                <strong>{' ' + itemName}</strong>
                                :
                                <>
                                    <strong>{' ' + t(userTypeDrop[userType])}</strong>
                                    <strong>{' ' + employeeName}</strong>
                                </>
                            }
                            {'?'}
                        </span>
                    </div>
                </div>
            </CustomModal>
        </>
    );
};

export default ApproveDocumentModal;
